import { render, staticRenderFns } from "./MerchantSelectDia.vue?vue&type=template&id=01b069a0&scoped=true"
import script from "./MerchantSelectDia.vue?vue&type=script&lang=js"
export * from "./MerchantSelectDia.vue?vue&type=script&lang=js"
import style0 from "./MerchantSelectDia.vue?vue&type=style&index=0&id=01b069a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b069a0",
  null
  
)

export default component.exports